import { uiTypeIs, rankWith } from '@jsonforms/core'
import { CHECKBOX_SELECTION_RENDERER_META } from './CheckboxSelectionControl'

export default rankWith(
  5, // increase rank as needed
  uiTypeIs(CHECKBOX_SELECTION_RENDERER_META.type)
)
